import { render, staticRenderFns } from "./applyFlowDetail.vue?vue&type=template&id=70885c36&scoped=true&"
import script from "./applyFlowDetail.vue?vue&type=script&lang=js&"
export * from "./applyFlowDetail.vue?vue&type=script&lang=js&"
import style0 from "./applyFlowDetail.vue?vue&type=style&index=0&id=70885c36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70885c36",
  null
  
)

export default component.exports